import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../common/state';
import { fitInOneLine } from '../../../state/tags/fit_tags_in_one_line';
import { isFiltersRedesignExperimentEnabled } from '../../../../selectors/isFiltersRedesignExperimentEnabled';
import { FitInOneLine } from './index';

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const { isFitInOneLineEnabled } = state.filters.tagsOptions;

    return {
      enabled: isFitInOneLineEnabled,
      withNewTag: isFiltersRedesignExperimentEnabled(state),
    };
  },
  (dispatch: Dispatch) => ({
    toggle: (value: boolean) => {
      dispatch(fitInOneLine(value));
    },
  }),
)(FitInOneLine);
